export default {
      id: "Icon--arrowLeft-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--arrowLeft",
      toString: function () {
        return this.url;
      }
    }